<button mat-icon-button class="close close-button" *ngIf="!needChangePassword">
  <mat-icon class="close" (click)="sidenav.controller.close()">close</mat-icon>
</button>

<mat-tab-group class="settings-tab" color="primary" disableRipple>
  <mat-tab label="SECURITY">
    <app-security
      (onPasswordChanged)="sidenav.controller.close()"
    ></app-security>
  </mat-tab>
  <mat-tab label="NOTIFICATIONS" *ngIf="!needChangePassword">
    <app-notifications></app-notifications>
  </mat-tab>
</mat-tab-group>
